/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnLeftUpIcon32Regular = forwardRef('ArrowDUturnLeftUpIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M.77 12.316a1 1 0 0 0 1.46 1.368L8 7.529V17.5C8 23.3 12.701 28 18.5 28S29 23.3 29 17.5V10a1 1 0 1 0-2 0v7.5a8.5 8.5 0 0 1-17 0V7.53l5.77 6.155a1 1 0 1 0 1.46-1.368l-6.041-6.444a3 3 0 0 0-4.378 0l-6.04 6.444Z" })));
});
